import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

import {
  KioskProductAddPageDataSource,
  KioskProductAddPageViewModel,
} from './kiosk-product-add-page-view-model';

@Injectable()
export class KioskProductAddPageStoreDataSource implements KioskProductAddPageDataSource {
  readonly vm$: Observable<KioskProductAddPageViewModel | null> = of(null);
}
